export const TRACE_PARENT = 'traceparent';
export const TRACE_STATE = 'tracestate';
export const TRACE_MFE_ORIGIN = 'mfe-origin';
